import type { Grid2 as Grid } from '@mui/material';
import type { ComponentProps } from 'react';
import { useValuationsStore } from '../../../../store/valuationsStore';
import { SubCol } from '../../../Col';
import { Metric } from '../Metric';
import { SummaryCardContentGrid } from '../SummaryCardContentGrid';
import type { Metric as MetricType } from '../types';
import { useFinancialConsiderationsMetrics } from './useFinancialConsiderationsMetrics';

const PROJECT_KPI_LABEL = 'PROJECT KPIs';

const BreakEven = ({ projectKpiMetrics }: { projectKpiMetrics: MetricType[] }) => {
  if (projectKpiMetrics.length === 0) {
    return null;
  }

  return (
    <SubCol
      subColumnTitle={PROJECT_KPI_LABEL}
      textTransform='none'
      data-id='financial-considerations-project-kpi'
      sx={{ mt: 'auto' }}
    >
      <SummaryCardContentGrid
        sx={{ pt: '0.5rem' }}
        gridTemplateColumns={{
          md: 'repeat(1, 1fr)',
        }}
        data-id='financial-considerations-project-kpi-grid'
      >
        {projectKpiMetrics.map(metric => (
          <Metric
            key={metric.label}
            label={metric.label}
            value={metric.value}
            {...(metric.unit ? { unit: metric.unit } : {})}
          />
        ))}
      </SummaryCardContentGrid>
    </SubCol>
  );
};

const FinancialConsiderationsView = ({ ...props }: ComponentProps<typeof Grid>) => {
  const selectedAssetDetails = useValuationsStore.use.selectedAssetDetails();
  const { metrics, projectKpiMetrics } = useFinancialConsiderationsMetrics(selectedAssetDetails);

  const hasContent = metrics.length > 0 || projectKpiMetrics.length > 0;

  if (!hasContent) {
    return null;
  }

  return (
    <>
      <SummaryCardContentGrid {...props} data-id='financial-considerations-view'>
        {metrics.map(metric => (
          <Metric
            key={metric.label}
            label={metric.label}
            value={metric.value}
            {...(metric.unit ? { unit: metric.unit } : {})}
          />
        ))}
      </SummaryCardContentGrid>

      <BreakEven projectKpiMetrics={projectKpiMetrics} />
    </>
  );
};

export { FinancialConsiderationsView };
